import { render, staticRenderFns } from "./TimeTable.vue?vue&type=template&id=3996236f&scoped=true"
import script from "./TimeTable.vue?vue&type=script&lang=js"
export * from "./TimeTable.vue?vue&type=script&lang=js"
import style0 from "./TimeTable.vue?vue&type=style&index=0&id=3996236f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996236f",
  null
  
)

export default component.exports